import { Link } from 'react-router-dom';
import { FullLogo } from './Logo';
import { FOOTER_LINKS } from '../config/site';
import { EXT, openExternal } from '../config/links';
import { Cta } from './common';

export default function Footer() {
  return (
    <footer className="pt-20 pb-10 border-t" style={{ borderColor: 'var(--border)', background: 'var(--bg-2)' }}>
      <div className="container-x">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <FullLogo height={42} />
            <p className="mt-5 text-[14px] leading-relaxed text-[var(--muted)] max-w-[320px]">AI-powered market intelligence and trading infrastructure — unified in one institutional-grade platform.</p>
            <div className="mt-6 flex gap-3">
              <Cta size="sm" href={EXT.SIGNUP} onClick={() => openExternal(EXT.SIGNUP, 'signup_click')}>Start Trading</Cta>
              <Cta size="sm" variant="outline" href={EXT.CONTACT} onClick={() => openExternal(EXT.CONTACT, 'contact_click')}>Contact</Cta>
            </div>
          </div>
          {Object.entries(FOOTER_LINKS).map(([group, links]) => (
            <div key={group}>
              <div className="font-mono text-[11px] tracking-[0.18em] text-[var(--muted-2)] mb-5">{group.toUpperCase()}</div>
              <ul className="flex flex-col gap-3.5">
                {links.map((l) => (
                  <li key={l.label}><Link to={l.to} className="text-[14px] text-[var(--muted)] hover:text-[var(--gold-3)] transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="gold-divider my-10" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[12px] text-[var(--muted-2)]">© 2026 Kalki AI. All rights reserved.</p>
          <p className="font-mono text-[11px] text-[var(--muted-2)] max-w-[560px] md:text-right leading-relaxed">Trading involves significant risk. Historical and backtested results do not guarantee future performance. Kalki AI provides intelligence and execution tools, not financial advice.</p>
        </div>
      </div>
    </footer>
  );
}
